import { SearchIcon } from '@approvalmax/ui';
import { Box, TextField } from '@approvalmax/ui/src/components';
import { eventHelpers, hooks } from '@approvalmax/utils';
import { KeyboardEventHandler, memo, useCallback, useState } from 'react';
import { useDebounce, useUnmount } from 'react-use';

import { searchValueQueryParam } from '../../../../constants';
import { messages } from './Filter.messages';

export const Filter = memo(() => {
    const [searchValue, setSearchValue] = hooks.useQueryParam(searchValueQueryParam);

    const [inputValue, setInputValue] = useState(searchValue || '');

    const handleInputChange = useCallback((value: string) => {
        setInputValue(value);
    }, []);

    const [, cancel] = useDebounce(
        () => {
            setSearchValue(inputValue);
        },
        300,
        [inputValue]
    );

    useUnmount(() => {
        cancel();
    });

    const onKeyDown = useCallback<KeyboardEventHandler>((event) => {
        if (event.key === 'Escape') {
            setInputValue('');
        }
    }, []);

    return (
        <Box spacing='12 24 12 60'>
            {/* wrap in form to prevent autofill when logout popup shows */}
            <form autoComplete='off' onSubmit={eventHelpers.preventDefaultCallback}>
                <TextField
                    name='search'
                    placeholder={messages.searchPlaceholder}
                    size='small'
                    startIcon={<SearchIcon color='midnight60' />}
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyDown={onKeyDown}
                />
            </form>
        </Box>
    );
});

Filter.displayName = 'Filter';
